<template>
  <div class="sale-subscription-filter">
    <form-group
      v-model="form.finished_order"
      id="finished-select"
      label="Status da compra"
      placeholder="Selecione o status"
      select
      :options="statuses"
    />

    <form-group
      v-model="form.product_id"
      id="product-select"
      label="Produto"
      placeholder="Todos os produtos"
      select
      :options="productOptions"
    />

    <action-dispatcher
      v-if="form.product_id"
      :action="isSignature ? 'plan/get' : 'offer/get'"
      :parameters="{ product_id: form.product_id, limit: 1000 }"
    >
      <form-group
        v-if="isSignature"
        slim
        select
        id="offer-select"
        label="Plano"
        v-model="form.plan_id"
        placeholder="Selecionar o plano..."
        :options="plansOptions"
        :errors="errors.plan_id"
      />
      <form-group
        v-else
        slim
        select
        id="offer-select"
        label="Oferta"
        v-model="form.offer_id"
        placeholder="Selecione a oferta..."
        :options="offersOptions"
        :errors="errors.offer_id"
      />
    </action-dispatcher>

    <form-group
      v-model="form.sck"
      id="sck"
      label="Parâmetro SCK"
      placeholder="Digite..."
    />

    <div
      class="d-flex flex-column flex-md-row d-block justify-content-between mt-9 pb-5"
    >
      <button class="btn btn-new-secondary btn-block mr-3" @click="cancel">
        Cancelar
      </button>
      <button
        class="btn btn-new-primary btn-block m-lg-0 m-md-0"
        @click="apply"
      >
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statuses: [
        { id: "", name: "Todos" },
        { id: "false", name: "Realizada" },
        { id: "true", name: "Incompleta" }
      ],
      ...formFields(
        ["finished_order", "product_id", "offer_id", "plan_id", "sck"],
        { ...this.value }
      )
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    },
    plansOptions() {
      return [{ id: "", name: "Todos os planos" }, ...this.plans];
    },
    offersOptions() {
      return [{ id: "", name: "Todas as ofertas" }, ...this.offers];
    },
    isSignature() {
      const slctdPrdct = this.products.find(p => p.id === this.form.product_id);
      return get(slctdPrdct, "type_product") === "signature";
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
    },
    cancel() {
      this.$emit("cancel-modal");
    }
  }
};
</script>
